import React from 'react'
import { Link } from "react-scroll";
import Logo from "../layouts/Logo";
import { navLinksdata, profile } from "../../constants";
import SocialIcons from "../layouts/SocialIcons";

const Footer = () => {
  return (
    <footer className="sectionWrap !py-20 h-auto grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 gap-10">
      <div className="w-full h-full flex flex-col gap-6">
        <Logo />
        <p className="text-base text-gray-400 leading-7 max-w-sm">
          {profile.role} shipping cloud-native platforms and production AI — from first customer conversation to launch.
        </p>
        <SocialIcons />
      </div>
      <div className="w-full h-full">
        <h3 className="text-xl uppercase text-designColor tracking-wider">
          Quick Links
        </h3>
        <ul className="flex flex-col gap-4 font-titleFont font-medium py-6 overflow-hidden">
          {navLinksdata.map(({ _id, title, link }) => (
            <li key={_id}>
              <Link
                to={link}
                smooth={true}
                offset={-70}
                duration={500}
                className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer"
              >
                {title}
                <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="w-full h-full">
        <h3 className="text-xl uppercase text-designColor tracking-wider">
          Get In Touch
        </h3>
        <ul className="flex flex-col gap-4 font-titleFont font-medium py-6 text-gray-400">
          <li>
            <a href={`mailto:${profile.email}`} className="text-lg hover:text-designColor duration-300 break-all">
              {profile.email}
            </a>
          </li>
          <li>
            <a href={`tel:${profile.phone.replace(/\s/g, "")}`} className="text-lg hover:text-designColor duration-300">
              {profile.phone}
            </a>
          </li>
          <li className="text-lg">{profile.location}</li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer
